import { TemplateElement, html, defineElement, unsafeHTML, when } from '@webtides/element-js';
import style from './comparison-card.css';

/**
 * @property {string} highlightText
 * @property {string} headline
 * @property {string} text
 * @property {string} benefitsLabel
 * @property {string[]} benefits
 * @property {string[]} facts
 * @property {object} link
 */
export default class ComparisonCard extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            highlightText: '',
            headline: '',
            text: '',
            benefitsLabel: 'Your Benefits',
            benefits: [],
            facts: [],
            link: undefined,
        };
    }

    template() {
        // TODO: copy checkmark (there are already two different ones...) icon into project.
        return html`
            <div class="relative h-full rounded-2xl pt-[42px]">
                <div
                    class="absolute left-0 right-0 top-0 rounded-2xl ${when(
                        this.highlightText,
                        'bg-green-medium',
                        '',
                    )} text-center text-white pt-8 pb-32 min-h-[1lh] fix-body1-medium"
                >
                    ${this.highlightText}
                </div>
                <div
                    class="relative bg-white rounded-2xl flex flex-col gap-24 md:gap-32 h-full p-24"
                    style="border: 2px solid ${when(this.highlightText, '#144B3C', '#C4D2CE')};"
                >
                    <div>
                        <h3 class="mb-8 fix-title3-medium">${this.headline}</h3>
                        <div
                            class="text mb-0 after:content-[''] after:relative after:inline-block after:w-[110px] after:h-[1em] text-green-light fix-body2"
                        >
                            ${unsafeHTML(this.text)}
                        </div>
                    </div>
                    <div class="flex-1">
                        <strong class="mb-16 fix-body2-medium">${this.benefitsLabel}</strong>
                        <ul class="mb-0 list-disc">
                            ${this.benefits.map(
                                (benefit) => html`
                                    <li
                                        class="flex items-start gap-16 mt-16 fix-body2 ${when(
                                            benefit.enabled,
                                            'text-green-medium',
                                            'text-green-light',
                                        )}"
                                    >
                                        ${when(
                                            benefit.enabled,
                                            html`
                                                <svg
                                                    width="24"
                                                    height="25"
                                                    viewBox="0 0 24 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    class="shrink-0"
                                                >
                                                    <path
                                                        d="M20 6.68994L9 17.6899L4 12.6899"
                                                        stroke="#144B3C"
                                                        stroke-width="1.68"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            `,
                                            html`
                                                <svg
                                                    width="24"
                                                    height="25"
                                                    viewBox="0 0 24 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M18 6.68994L6 18.6899M6 6.68994L18 18.6899"
                                                        stroke="#6B7A6C"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            `,
                                        )}
                                        ${benefit.text}
                                    </li>
                                `,
                            )}
                        </ul>
                    </div>
                    <div>
                        ${this.facts.map(
                            (fact) => html`
                                <div class="flex items-start justify-between gap-16 mb-16">
                                    <strong class="fix-body2-medium">${fact.label}</strong>
                                    <div class="fix-body3">${fact.text}</div>
                                </div>
                            `,
                        )}
                    </div>
                    <a href="${this.link.url}" class="Button btn btn-primary w-full" element="comparison card"
                        >${this.link.text}</a
                    >
                </div>
            </div>
        `;
    }
}

defineElement('mb-comparison-card', ComparisonCard);
